export const Statuszok = Object.freeze({
  Cleaned: 'status_cleaned',
});
